
import React from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import CampaignSetup from './Campaigns/ManageCampaign/CampaignSetup'
import Leads from './Leads'
import Campaigns from './Campaigns'
import Support from './Support'
import Analytics from './Analytics'
import Blog from './Blog'
import LinearProgress from '@material-ui/core/LinearProgress';

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = theme => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    height: '100%',
  },
});

@inject("commonStore")
@observer
class MainView extends React.Component {
  state = {
    value: 0,
  };
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    // document.removeEventListener('keydown', this.onKeydown);
    const width = window.innerWidth;
    const height = window.innerHeight;

    this.setState({ height, width });
  }

  handleChange = (event, value) => {
    const { commonStore } = this.props
    const { clearCampaign } = commonStore
    clearCampaign()
    this.setState({ campaign: {}, value });
  }

  selectCampaign = (campaign) => {
    console.log('selectCampaign')
    console.log(campaign)
    this.setState({campaign: campaign, value: 2})
  }

  campaignFinished = (campaign) => {
    this.setState({ value: 1})
  }
  
  render() {
    const { classes, showTabs, commonStore } = this.props;
    const { value, analytics } = this.state;
    const { loading, agent, network } = commonStore

    const { agentBlogLink, agentBuyerLink } = network

    return (
      <div className={classes.root}>
      {loading ? <LinearProgress color="secondary" /> : null}
        <AppBar position="static">
          {showTabs ? <Tabs value={value} onChange={this.handleChange}>
            <Tab label="Leads" />
            <Tab label="Campaigns" />
            <Tab label="Campaign Builder" />
            <Tab label="Analytics" />
            {/*agentBlogLink ? <Tab label="Updates" /> : null*/}
            {agentBuyerLink ? <Tab label="Lead Info" /> : null}
            <Tab label="Support" />
    </Tabs> : null}
        </AppBar>
        {value === 0 && <TabContainer><Leads /></TabContainer>}
        {value === 1 && <TabContainer><Campaigns selectCampaign={this.selectCampaign}/></TabContainer>}
        {value === 2 && <TabContainer><CampaignSetup {...this.state} campaignFinished={this.campaignFinished} /></TabContainer>}
        <div style={{display: value === 3 ? 'block' : 'none' }}><TabContainer><Analytics {...this.state} /></TabContainer></div>
        {/*value === 4 && <TabContainer><Blog url={agentBlogLink} /></TabContainer>*/}
        {value === 4 && <TabContainer><Blog url={agentBuyerLink} /></TabContainer>}
        {value === 5 && <TabContainer><Support /></TabContainer>}
      </div>
    );
  }
}

MainView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainView);



// WEBPACK FOOTER //
// ./src/components/Leads/MainView.js